module.exports = __webpack_public_path__ + "img/trash-icon.65142064.svg";